import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Select from "react-select";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { getAllPages, getMenuByID, editMenu } from "../../api/api";
import Loader from "../loader/loader";

const NavList = (props) => {
  const menuPic = [
    {
      value: "Home",
      label: "Home",
    },
    {
      value: "Music",
      label: "Music",
    },
    {
      value: "Star",
      label: "Star",
    },
    {
      value: "Document",
      label: "Document",
    },
    {
      value: "Padlock",
      label: "Padlock",
    },
    {
      value: "Dollar",
      label: "Dollar",
    },
    {
      value: "Crown",
      label: "Crown",
    },
    {
      value: "Audio",
      label: "Audio",
    },
    {
      value: "Profile",
      label: "Profile",
    },
    {
      value: "Bar Menu",
      label: "Bar Menu",
    },
    {
      value: "Dot Menu",
      label: "Dot Menu",
    },
    {
      value: "Bell",
      label: "Bell",
    },
    {
      value: "Video",
      label: "Video",
    },
    {
      value: "Sort",
      label: "Sort",
    },
    {
      value: "Photo",
      label: "Photo",
    },
    {
      value: "Eye",
      label: "Eye",
    },
    {
      value: "Search",
      label: "Search",
    },
    {
      value: "Movie",
      label: "Movie",
    },
    {
      value: "Setting",
      label: "Setting",
    },
    {
      value: "Globe",
      label: "Globe",
    },
    {
      value: "Folder",
      label: "Folder",
    },
    {
      value: "Paint",
      label: "Paint",
    },

    {
      value: "Cast",
      label: "Cast",
    },
    {
      value: "Refresh",
      label: "Refresh",
    },
    {
      value: "Play",
      label: "Play",
    },
    {
      value: "Stop",
      label: "Stop",
    },
    {
      value: "Pause",
      label: "Pause",
    },
    {
      value: "Trash",
      label: "Trash",
    },
    {
      value: "Close",
      label: "Close",
    },
    {
      value: "Back Arrow",
      label: "Back Arrow",
    },
    {
      value: "Forward Arrow",
      label: "Forward Arrow",
    },
    {
      value: "Down Arrow",
      label: "Down Arrow",
    },
    {
      value: "Up Arrow",
      label: "Up Arrow",
    },
    {
      value: "Live",
      label: "Live",
    },
  ];
  const menu_data = {
    application: "",
    date: "",
    externalUrl: null,
    internalUrl: null,
    items: [],
    menuIcon: "",
    menuOrder: "",
    menuPage: null,
    menuTitle: "",
    menuType: "",
    urlName: "",
    _id: "",
  };

  const [options, setOptions] = useState([]);
  const [allIcon, setIcon] = useState(menuPic);
  const [characters, updateCharacters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [final, setFinal] = useState([menu_data]);
  const [menuPage, setmenuPage] = useState("");
  const [menuIcon, setmenuIcon] = useState("");
  const [menuurlName, setmenuUrlName] = useState("");
  const [menuPageType, setmenuPageType] = useState("");
  const [menuPageRef, setmenuPageRef] = useState("");
  const [menuTitle, setmenuTitle] = useState("");
  const { dir } = props.location.state;
  // const [dir] = useState("rtl");

  useEffect(() => {
    const getPaged = async () => {
      try {
        const appl = await getAllPages(200, 0);

        const pages = appl.data.pages;

        const imageCount = appl.data.count;

        const opt = pages.map((item) => ({
          value: item._id,
          label: item.referenceName,
          urlName: item.urlName,
          pageType: item.pageType,
        }));
        setOptions(opt);
      } catch (error) {}
    };

    const getMenus = async (id) => {
      setLoading(true);
      try {
        const appl = await getMenuByID(id);

        const newArray = appl.data;
        if (appl.data.length !== 0) {
          setFinal(newArray);
          newArray.items !== null
            ? updateCharacters(newArray.items)
            : updateCharacters([]);
        }
        setLoading(false);
      } catch (error) {
        toastr.error("Unable to Load Data", "Error");
        setLoading(false);
      }
    };
    getPaged();
    getMenus(props.match.params.id);
  }, [props.match.params.id]);

  const onChangePage = (value, evt) => {
    setmenuPage(value.value);
    setmenuPageType(value.pageType);
    setmenuPageRef(value.label);
    setmenuUrlName(value.urlName);
    setIcon(menuPic);
  };
  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.menuOrder = index + 1;
      return item;
    });
    updateCharacters(newItems);
  };
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);
    reorderArray(items);
  };

  const handlePublish = async (event) => {
    const newArray = final;
    newArray.items = characters;
    setFinal(newArray);
    event.preventDefault();
    setLoading(true);
    /* eslint-disable no-unused-vars */

    const result = await editMenu(final, props.match.params.id).then(
      (result) => {
        toastr.success("Successfully Saved", "Success");

        setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
  };

  const handleChange = (event) => {
    if (event.target.name === "menuTitle") {
      setmenuTitle(event.target.value);
    }
  };
  const onChangeItemed = (value, event) => {
    setmenuIcon(value.value);
  };

  const checkValueExist = (value, type) => {
    return characters.some(function (el) {
      if (type === "menuPage") {
        return el.menuPage === value;
      } else if (type === "menuTitle") {
        return el.menuTitle === value;
      } else if (type === "menuurlName") {
        return el.menuurlName === value;
      } else {
        return el.menuPage === value;
      }
    });
  };
  const handleSave = (evt) => {
    evt.preventDefault();
    const opt = {
      menuPage: menuPage,
      menuPageRef: menuPageRef,
      menuPageType: menuPageType,
      menuUrlName: menuurlName,
      menuTitle: menuTitle,
      menuOrder: characters.length + 1,
      menuIcon: menuIcon,
    };
    if (
      !checkValueExist(opt.menuPage, "menuPage") &&
      !checkValueExist(opt.menuTitle, "menuTitle") &&
      !checkValueExist(opt.menuUrlName, "menuurlName")
    ) {
      updateCharacters([...characters, opt]);
    } else {
      toastr.error("Menu Title/Url Name/Page Already Exist", "Error");
    }
  };

  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(index, 1);

    reorderArray(items);
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      dir === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Add Dropdown Menu
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row">
                          <div
                            className="col-md-4"
                            dir={dir === "rtl" ? "rtl" : "ltr"}
                          >
                            <label
                              className={
                                dir === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Pages
                            </label>
                            <Select
                              name="pageId"
                              className={
                                dir === "rtl"
                                  ? "form-control inside-select float-right"
                                  : "form-control inside-select float-left"
                              }
                              options={options}
                              onChange={(value, event) =>
                                onChangePage(value, event)
                              }
                            ></Select>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className={
                                  dir === "rtl" ? "float-right" : "float-left"
                                }
                                style={{ marginTop: "6px" }}
                              >
                                Menu Name *
                              </label>
                              <input
                                type="text"
                                name="menuTitle"
                                className="form-control inside-form"
                                placeholder="Name..."
                                autoComplete="off"
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div
                              className="form-group"
                              dir={dir === "rtl" ? "rtl" : "ltr"}
                            >
                              <label
                                className={
                                  dir === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                Menu Icon
                              </label>
                              <Select
                                name="menuIcon"
                                className={
                                  dir === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                options={allIcon}
                                onChange={(value, event) =>
                                  onChangeItemed(value, event)
                                }
                              ></Select>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <button
                                type="button"
                                className={
                                  dir === "rtl"
                                    ? "btn btn-primary float-left"
                                    : "btn btn-primary float-right"
                                }
                                style={{
                                  width: "100px",
                                  marginRight: "6px",
                                  // float: "right",
                                }}
                                onClick={handleSave}
                              >
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12">
                      <div className="row mb-2 mt-2"></div>
                      <div className="card-header" style={{ padding: "0px" }}>
                        <label
                          className={
                            dir === "rtl" ? "float-right" : "float-left"
                          }
                        >
                          Menu Container
                        </label>
                      </div>
                      {characters ? (
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                          <Droppable droppableId={"characters"}>
                            {(provided) => (
                              <ul
                                className="products-list product-list-in-card pl-2 pr-2"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={{
                                  maxHeight: "450px",
                                  overflowY: "scroll",
                                }}
                              >
                                {characters.map((item, index) => (
                                  <Draggable
                                    key={item.menuPage + item.menuOrder}
                                    draggableId={"item" + item.menuOrder}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <li
                                        className="item"
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <div
                                          className={
                                            dir === "rtl"
                                              ? "product-info float-right"
                                              : "product-info float-left"
                                          }
                                        >
                                          <a
                                            href={
                                              "/" +
                                              item.menuPageType +
                                              "/" +
                                              item.menuPage
                                            }
                                            className="product-title"
                                          >
                                            {item.menuPageRef}
                                            <span
                                              className={
                                                dir === "rtl"
                                                  ? "badge badge-warning float-right"
                                                  : "badge badge-warning float-left"
                                              }
                                            >
                                              {item.menuOrder}
                                            </span>
                                          </a>

                                          <span
                                            className="product-description"
                                            style={
                                              dir === "rtl"
                                                ? { marginRight: "55px" }
                                                : { marginLeft: "55px" }
                                            }
                                          >
                                            {"Menu Title :" + item.menuTitle}
                                          </span>
                                          <span
                                            className="product-description"
                                            style={
                                              dir === "rtl"
                                                ? { marginRight: "55px" }
                                                : { marginLeft: "55px" }
                                            }
                                          >
                                            {"Icon: " + item.menuIcon}
                                          </span>
                                        </div>
                                        <div
                                          className="text-right"
                                          style={
                                            dir === "rtl"
                                              ? {
                                                  display: "inline",
                                                  float: "left",
                                                }
                                              : {
                                                  display: "inline",
                                                  float: "right",
                                                }
                                          }
                                        >
                                          <a
                                            className="btn btn-light btn-sm"
                                            href="#!"
                                            onClick={(event) =>
                                              handleRemove(event, index)
                                            }
                                          >
                                            <i className="fas fa-trash"></i>
                                          </a>
                                        </div>
                                      </li>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </ul>
                            )}
                          </Droppable>
                        </DragDropContext>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <button
                        type="button"
                        className={
                          dir === "rtl"
                            ? "btn btn-primary float-left"
                            : "btn btn-primary float-right"
                        }
                        style={{
                          width: "100px",
                          marginRight: "25px",
                          marginLeft: "20px",
                          // float: "right",
                          marginBottom: "12px",
                        }}
                        onClick={handlePublish}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default NavList;
